/**
 * Controls the visibility of MPAN/MPRN fields, that would be hidden
 * unless it's necessary for the user to fill them (if the address
 * they picked doesn't have any MPAN/MPRN set already)
 * @module embed/mpan_mprn_fields
 */

import { delegate } from '@/lib/events';
import { show, hide } from '@/lib/show_hide';
import { EVENT_FORM_ERROR } from '@/lib/simpleFormErrors';
import { getSupplyAddress } from './form';
import { SELECTOR_ADDRESS_SUPPLY } from './address';

const SELECTOR = '.js-mpan-mprn';
const SELECTOR_FIELD = '.js-mpan-mprn-field';
const SELECTOR_INPUT = '.js-mpan-mprn__input';

/**
 * @param {HTMLElement} scope The form on which to listen to events
 */
export default function setupMpanMprnFields(scope) {
  //
  hideUntilAddressChosen(scope);
  // Controls the visibility of the group of fields
  // to ensure separator gets hidden properly when both
  // are pre-filled
  setupFieldsVisibility(scope);
  // Controls the visibility of each field
  // depending of whether it's filled or not
  setupIndividualFieldsVisibility(scope);
}

function hideUntilAddressChosen(scope) {
  const widget = document.querySelector(SELECTOR);
  if (widget) {
    // Hide if the address is not filled
    if (!getSupplyAddress(scope)) {
      hide(widget);
    }
    // Reveal when user choses to enter address manually
    scope.addEventListener(
      'didShowAddressInput',
      delegate(SELECTOR_ADDRESS_SUPPLY, () => {
        show(widget);
      })
    );
  }
}

function setupFieldsVisibility(scope) {
  // When numbers get pre-filled, hide (not disable) the fields
  // if the pre-filling clears them show the fields for users to edit
  let timeout;
  scope.addEventListener(
    'change',
    delegate(SELECTOR, (event, delegateTarget) => {
      // Check if it's a CustomEvent, which means the form was pre-filled
      if (event instanceof CustomEvent) {
        // Skip a frame here to wait for both fields to have been filled
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
          const inputs = Array.from(
            delegateTarget.querySelectorAll(SELECTOR_INPUT)
          );
          // Filter filled values
          const filledValues = inputs.map(el => el.value).filter(Boolean);

          // Hide the whole field if all input are set
          if (filledValues.length == inputs.length) {
            hide(delegateTarget);
          } else {
            show(delegateTarget);
          }
        }, 0);
      }
    })
  );

  // Reveal the fields if a validation error happens
  scope.addEventListener(
    EVENT_FORM_ERROR,
    delegate(SELECTOR, (event, delegateTarget) => {
      show(delegateTarget);
    })
  );
}

function setupIndividualFieldsVisibility(scope) {
  scope.addEventListener(
    'change',
    delegate(SELECTOR_FIELD, (event, target) => {
      // Check if it's a CustomEvent, which means the form was pre-filled
      if (event instanceof CustomEvent) {
        // `event.target` is the one that actually holds the field
        if (event.target.value) {
          hide(target);
        } else {
          show(target);
        }
      }
    })
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/mpan_mprn_fields.js